module.exports = __webpack_public_path__ + "img/app2.4b2b80bd.png";